import BASKET_ROWS_TYPES from '@constants/basketRowsTypes';

type BasketRow = {
  '@type'?: string;
  dishSize?: { dish?: { excludedFromDiscountCodes?: boolean } };
};

const DISCOUNTABLE_ROWS_TYPES: (string | undefined)[] = [
  BASKET_ROWS_TYPES.DIET_ITEM,
  BASKET_ROWS_TYPES.DISH_ITEM,
  BASKET_ROWS_TYPES.ADDON_ITEM,
  BASKET_ROWS_TYPES.MEAL_TYPE_ITEM,
];

const hasOnlyDiscountExcludedDishes = (rows: BasketRow[] = []) => {
  const discountableRows = rows.filter(row =>
    DISCOUNTABLE_ROWS_TYPES.includes(row?.['@type'])
  );

  if (discountableRows.length === 0) {
    return false;
  }

  return discountableRows.every(
    row =>
      row['@type'] === BASKET_ROWS_TYPES.DISH_ITEM &&
      row.dishSize?.dish?.excludedFromDiscountCodes === true
  );
};

export default hasOnlyDiscountExcludedDishes;
